export class MinsterDate {

    /**
     *
     */
    constructor(year: number | null, month: number | null, day: number | null) {
        this.year = year;
        this.month = month;
        this.day = day;
    }

     /**
     * The year, for example 2016
     */
      year: number | null;
      /**
       * The month, for example 1=Jan ... 12=Dec
       */
      month: number | null;
      /**
       * The day of month, starting at 1
       */
      day: number | null;
}

